import React from "react";
import { Text, View } from "@react-pdf/renderer";

import SelectGroup from "../../../../exportacion_react_pdf/SelectGroup";
import QuestionResponse from "../../../../exportacion_react_pdf/QuestionResponse";
import CheckboxGroup from "../../../../exportacion_react_pdf/CheckboxGroup";
import TextAreaLabel from "../../../../exportacion_react_pdf/TextAreaLabel";
import TableGroup from "../../../../exportacion_react_pdf/TableGroup";

// Define el documento
const ExportAgricolaPaso6 = ({ formData, styles }) => (
    <>
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
            <Text style={styles.title_1}>
                Características del predio Áreas en hectareas
            </Text>

            <QuestionResponse
                label={"Área en producción"}
                value={formData?.agricola?.area_produccion || ""}
            ></QuestionResponse>
            <QuestionResponse
                label={"Área en bosque, barbecho, huerta"}
                value={formData?.agricola?.area_bosque || ""}
            ></QuestionResponse>
            <QuestionResponse
                label={"Área del predio total"}
                value={formData?.agricola?.area_predio || ""}
            ></QuestionResponse>
            <QuestionResponse
                label={"N° de plantas sembradas"}
                value={formData?.agricola?.numero_plantas_sembradas || ""}
            ></QuestionResponse>
            <TextAreaLabel
                label={"Distancia de siembra"}
                value={formData?.agricola?.distancia_sembrada || ""}
            ></TextAreaLabel>
            <TextAreaLabel
                label={"¿Qué variedad o clon tiene sembrada?"}
                value={formData?.agricola?.variedad_sembrada || ""}
            ></TextAreaLabel>

            <SelectGroup
                label={"Época lluvia, mes para siembras"}
                selectedValue={formData?.agricola?.meses_siembra || ""}
            ></SelectGroup>




            <CheckboxGroup
                label="¿Cuenta actualmente con los equipos necesarios para la prestación de su servicio?"
                selectedValue={formData?.agricola?.manejo_registros || ""}
                options={['Sí', 'No', 'A veces']}
            ></CheckboxGroup>

            <TableGroup
                questionTitle="Comercialización (producto fresco, producto seco , procesados, semillas, plántulas, colinos, etc...)"
                headers={["producto", "cantidad_mes_ano", "venta_unidad", "cliente"]}
                headerDescriptions={["Producto", "Cantidad / mes/año", "Venta/unidad", "Cliente"]}
                data={formData?.agricola?.lista_comercializacion}
            />


        </View>
    </>
);

export default ExportAgricolaPaso6;
